<template>
    <div class="hero-section section">
        <div class="heading3">

            {{ page_title }}
        </div>
    </div>
</template>
<script>
export default{
    props:{
        image: String,
        page_title: String
    }
}
</script>
<style scoped>

.heading3{
    margin:0.5rem 2.5rem;
}

.hero-section{
    background:var(--image),rgba(0, 0, 0, 0.5);
    background-blend-mode: multiply;
    display: flex;
    align-items: flex-end;
    
}

@media(max-width:768px){
    .hero-section{
        min-height:10rem;
    }

    .heading3{
    margin-left:1rem;
    margin-bottom:-1rem;
    font-size:2rem;
    }

    
}


</style>